import { render } from "./MonitorStudent.vue?vue&type=template&id=2ef77b82"
import script from "./MonitorStudent.vue?vue&type=script&lang=js"
export * from "./MonitorStudent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__